module.exports = function (Utils) {
    'use strict';
    function validateSegment(startTime, endTime, validationContext) {
        if (!Utils.isValidTime(startTime)) {
            throw new TypeError('peaks.segments.' + validationContext + ': startTime should be a valid number');
        }
        if (!Utils.isValidTime(endTime)) {
            throw new TypeError('peaks.segments.' + validationContext + ': endTime should be a valid number');
        }
        if (startTime < 0) {
            throw new RangeError('peaks.segments.' + validationContext + ': startTime should not be negative');
        }
        if (endTime < 0) {
            throw new RangeError('peaks.segments.' + validationContext + ': endTime should not be negative');
        }
        if (endTime <= startTime) {
            throw new RangeError('peaks.segments.' + validationContext + ': endTime should be greater than startTime');
        }
    }
    function Segment(parent, id, startTime, endTime, labelText, color, editable) {
        validateSegment(startTime, endTime, 'add()');
        this._parent = parent;
        this._id = id;
        this._startTime = startTime;
        this._endTime = endTime;
        this._labelText = labelText;
        this._color = color;
        this._editable = editable;
    }
    Object.defineProperties(Segment.prototype, {
        parent: {
            get: function () {
                return this._parent;
            }
        },
        id: {
            enumerable: true,
            get: function () {
                return this._id;
            }
        },
        startTime: {
            enumerable: true,
            get: function () {
                return this._startTime;
            },
            set: function (time) {
                this._startTime = time;
            }
        },
        endTime: {
            enumerable: true,
            get: function () {
                return this._endTime;
            },
            set: function (time) {
                this._endTime = time;
            }
        },
        labelText: {
            enumerable: true,
            get: function () {
                return this._labelText;
            }
        },
        color: {
            enumerable: true,
            get: function () {
                return this._color;
            }
        },
        editable: {
            enumerable: true,
            get: function () {
                return this._editable;
            }
        }
    });
    Segment.prototype.update = function (options) {
        var startTime = Object.prototype.hasOwnProperty.call(options, 'startTime') ? options.startTime : this.startTime;
        var endTime = Object.prototype.hasOwnProperty.call(options, 'endTime') ? options.endTime : this.endTime;
        var labelText = Object.prototype.hasOwnProperty.call(options, 'labelText') ? options.labelText : this.labelText;
        var color = Object.prototype.hasOwnProperty.call(options, 'color') ? options.color : this.color;
        var editable = Object.prototype.hasOwnProperty.call(options, 'editable') ? options.editable : this.editable;
        validateSegment(startTime, endTime, 'updateTime()');
        this._startTime = startTime;
        this._endTime = endTime;
        this._labelText = labelText;
        this._color = color;
        this._editable = editable;
        this._parent._peaks.emit('segments.update', this);
    };
    Segment.prototype.isVisible = function (startTime, endTime) {
        return this.startTime < endTime && startTime < this.endTime;
    };
    return Segment;
}(require('peaks/waveform/waveform.utils'));